import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { initLogoutAction } from '../../../actions';
import FullPageLoader from '../../atoms/FullPageLoader/FullPageLoader';
import './LogoutPage.scss';

const LogoutPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  useEffect(() => {
    setTimeout(() => {
      dispatch(initLogoutAction());
      history.push('/home');
    }, 2000);
  }, []);
  return (
    <div className="logout-page">
      <FullPageLoader content="Logging you out" />
    </div>
  );
};

LogoutPage.propTypes = {

};

LogoutPage.defaultProps = {

};

export default LogoutPage;
